import { render, staticRenderFns } from "./HumanMap.vue?vue&type=template&id=8adcfc2c&scoped=true"
import script from "./HumanMap.vue?vue&type=script&lang=js"
export * from "./HumanMap.vue?vue&type=script&lang=js"
import style0 from "./HumanMap.vue?vue&type=style&index=0&id=8adcfc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adcfc2c",
  null
  
)

export default component.exports